export default function brand_details()
{
    return({
        //Company Information
        name: "BCX Vantage",
        subtitle: "Asset Intelligence",
        sub_entity_name: "Portfolio Command",
        sub_entity_subtitle: "Executive Snapshot",

        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--bolide-logo")
        .replace(/['"]+/g, "")
    });
}
